(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxury-feedback-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFeedbackSection = (section) => {
      if (!section || section.dataset.feedbackInitialized === 'true') return;

      const sectionId = section.dataset.sectionId;
      const storageKey = `lxviFeedbackRating-${sectionId}`;

      const inputs = Array.from(
        section.querySelectorAll('input[name="contact[rating]"]')
      );

      const status = section.querySelector('[data-rating-status]');

      if (section.querySelector('[data-feedback-success]')) {
        sessionStorage.removeItem(storageKey);
        section.dataset.feedbackInitialized = 'true';
        return;
      }

      if (!inputs.length) {
        section.dataset.feedbackInitialized = 'true';
        return;
      }

      // Read the rating from the input's value ("4 out of 5"), never
      // from its position in the DOM — the stars are intentionally
      // rendered 5 -> 1 for the CSS fill effect, so index order no
      // longer matches rating order.
      const ratingOf = (input) => Number.parseInt(input.value, 10);

      const setStatus = (rating) => {
        if (!status) return;
        status.textContent = rating
          ? `Your selected rating: ${rating} out of 5`
          : '';
      };

      const applyRating = (rating, { persist = true } = {}) => {
        const target = inputs.find((input) => ratingOf(input) === rating);
        if (!target) return;

        target.checked = true;
        setStatus(rating);

        if (persist) {
          try {
            sessionStorage.setItem(storageKey, String(rating));
          } catch (error) {
            /* sessionStorage unavailable — fail silently */
          }
        }
      };

      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          const rating = ratingOf(input);
          setStatus(rating);
          try {
            sessionStorage.setItem(storageKey, String(rating));
          } catch (error) {
            /* sessionStorage unavailable — fail silently */
          }
        });
      });

      const queryRating = Number.parseInt(
        new URLSearchParams(window.location.search).get('rating'),
        10
      );

      let storedRating = null;
      try {
        storedRating = Number.parseInt(sessionStorage.getItem(storageKey), 10);
      } catch (error) {
        storedRating = null;
      }

      if (queryRating >= 1 && queryRating <= 5) {
        applyRating(queryRating);
      } else if (storedRating >= 1 && storedRating <= 5) {
        applyRating(storedRating, { persist: false });
      } else {
        const checkedInput = inputs.find((input) => input.checked);
        if (checkedInput) {
          setStatus(ratingOf(checkedInput));
        }
      }

      section.dataset.feedbackInitialized = 'true';
    };

    const initializeAll = (root = document) => {
      root
        .querySelectorAll('[data-feedback-section]')
        .forEach(initializeFeedbackSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
